import { twMerge } from 'tailwind-merge'

const BAR_HEIGHTS = ['h-2', 'h-3.5', 'h-5', 'h-6.5']

/**
 * Duolingo's level motif: four ascending bars with the ones above the learner's
 * level greyed out.
 */
export default function DuoSignalBars({
  filled,
  selected,
}: {
  /** How many of the four bars are lit (1-4). */
  filled: number
  selected: boolean
}) {
  return (
    <span aria-hidden="true" className="flex shrink-0 items-end gap-1">
      {BAR_HEIGHTS.map((height, index) => (
        <span
          className={twMerge(
            'w-2 rounded-full',
            height,
            index < filled
              ? selected
                ? 'bg-duo-primary'
                : 'bg-duo-line-dark'
              : 'bg-duo-line',
          )}
          key={height}
        />
      ))}
    </span>
  )
}
